import React, { Component } from 'react';
import {
    List, Button, InputNumber, Typography, Card, Modal, Input, Spin, Space, Tag, message, Divider
} from 'antd';
import {
    MinusOutlined, PlusOutlined, DeleteOutlined, ShoppingCartOutlined,
    SaveOutlined, StarOutlined, LoadingOutlined, ArrowLeftOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import firebase from "../../firebase";
import FavoriteCartAllSelect from "../CartSelect/FavoriteCartAllSelect";
import FavoriteCartAllSelectOtasuke from "../CartSelect/FavoriteCartAllSelectOtasuke";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Text, Title } = Typography;

function pad(n) {
    return n > 9 ? "" + n : "0" + n;
}

class MobileFavoriteCart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartNo: 0,
            carts: [],
            cartselect: false,
            selectedItem: null,
            modalSave: false,
            modalDelete: false,
            loading: false,
            carriage: 0,
        };
    }

    getCollection = () => {
        const { db, org, userOrg } = this.props;
        if (org && org.reseller && userOrg && userOrg.maker) {
            return db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        } else if (org && org.maker && userOrg && userOrg.reseller) {
            return db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.reseller && userOrg && userOrg.buyer) {
            return db.collection('items_sell').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.buyer && userOrg && userOrg.reseller) {
            return db.collection('items_sell').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        }
        return null;
    }

    getCarts = async () => {
        const { db, user, org } = this.props;
        const collection = this.getCollection();
        if (!org || !collection) return;

        this.setState({ loading: true });
        const fsRef = db.collection('favorite_set').doc(user.id).collection('favorite_set').doc(org.id);
        const fs = await fsRef.get();
        const fsData = fs.data();

        if (!fsData) {
            this.setState({ loading: false });
            return;
        }

        let hasChanged = false;
        for (let i = 0; i < 30; i++) {
            const cart = fsData[i];
            if (cart && cart.items) {
                delete cart['deletedItem'];
                await Promise.all(cart.items.map(async (item) => {
                    let prevPrice = item.price;
                    let prevDeletedItem = item.deletedItem;
                    delete item['deletedItem'];
                    delete item['deletedText'];

                    const itemSell = await collection.doc(item.id).get();
                    const itemSellData = itemSell.data();

                    if (!itemSellData) {
                        item.deletedItem = true;
                        item.deletedText = '販売終了';
                        cart.deletedItem = true;
                    } else if (!itemSellData['price'] || (itemSellData['price'][0] && !itemSellData['price'][0]['price'])) {
                        item.deletedItem = true;
                        item.deletedText = '要見積';
                        cart.deletedItem = true;
                    } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                        item.deletedItem = true;
                        item.deletedText = '要見積';
                        cart.deletedItem = true;
                    } else if (itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                        const expDate = itemSellData['price'][0]['expiration_date'].toDate();
                        if ((expDate.getTime() - this.props.dateNow) < 0) {
                            item.deletedItem = true;
                            item.deletedText = '要見積';
                            cart.deletedItem = true;
                        }
                    }

                    if (!item.deletedItem) {
                        let changed = updateItemFromSellData(item, itemSellData);
                        if (changed) hasChanged = true;
                    }
                    if (prevDeletedItem !== item.deletedItem) {
                        hasChanged = true;
                    }
                    if (prevPrice !== item.price && (prevPrice === undefined || Number(prevPrice) !== Number(item.price))) {
                        hasChanged = true;
                    }
                }));
            }
        }
        if (hasChanged) {
            await fsRef.set(fsData, { merge: true });
        }

        // cartNo sync with props.id
        let cartNo = (parseInt(this.props.id, 10) || 1) - 1;
        if (isNaN(cartNo)) cartNo = 0;

        let total = 0;
        if (fsData[cartNo] && fsData[cartNo].items) {
            fsData[cartNo].items.forEach(item => {
                if (!item.deletedItem) total += (item.count || 0) * (item.price || 0);
            });
        }

        // carriage calculation (same as desktop)
        let carriage_free = 0;
        let carriage = 0;
        if (org.maker && this.props.userOrg && this.props.userOrg.sellers) {
            this.props.userOrg.sellers.forEach(seller => {
                if (seller.organization === org.id) {
                    carriage_free = seller.carriage_free || 0;
                    carriage = seller.carriage || 0;
                }
            });
        }
        if (org.reseller && this.props.userOrg) {
            carriage_free = this.props.userOrg.carriage_free || 0;
            carriage = this.props.userOrg.carriage || 0;
        }
        const postage = total < carriage_free ? carriage : 0;

        this.setState({ carts: fsData, cartNo, carriage: postage, loading: false });
    }

    componentDidMount() {
        let cartNo = (parseInt(this.props.id, 10) || 1) - 1;
        if (isNaN(cartNo)) cartNo = 0;
        this.setState({ cartNo }, () => this.getCarts());
    }

    componentDidUpdate(prevProps) {
        if (this.props.org !== prevProps.org || this.props.userOrg !== prevProps.userOrg || this.props.id !== prevProps.id) {
            let cartNo = (parseInt(this.props.id, 10) || 1) - 1;
            if (isNaN(cartNo)) cartNo = 0;
            this.setState({ cartNo }, () => this.getCarts());
        }
    }

    saveToFirestore = (carts) => {
        const { db, user, org } = this.props;
        const cartMainRef = db.collection('favorite_set').doc(user.id);
        const cartRef = cartMainRef.collection('favorite_set').doc(org.id);
        cartMainRef.set({ dummy: 'test' }, { merge: true });

        const cartData = { ...carts[this.state.cartNo] };
        delete cartData['deletedItem'];
        delete cartData['deletedText'];

        return cartRef.set({
            [this.state.cartNo]: cartData,
            update: firebase.firestore.Timestamp.fromDate(new Date()),
        }, { merge: true });
    }

    updateCartState = (updatedItems) => {
        const carts = { ...this.state.carts };
        const cartBase = { ...(carts[this.state.cartNo] || {}) };
        cartBase.items = updatedItems;
        delete cartBase['deletedItem'];
        delete cartBase['deletedText'];
        carts[this.state.cartNo] = cartBase;
        this.setState({ carts });
        this.saveToFirestore(carts);
    }

    decrease = (index) => {
        const carts = { ...this.state.carts };
        const items = [...(carts[this.state.cartNo]?.items || [])];
        if (items[index] && items[index].count > 0) {
            items[index] = { ...items[index], count: items[index].count - 1 };
        }
        this.updateCartState(items);
    }

    increase = (index) => {
        const carts = { ...this.state.carts };
        const items = [...(carts[this.state.cartNo]?.items || [])];
        if (items[index]) {
            items[index] = { ...items[index], count: (items[index].count || 0) + 1 };
        }
        this.updateCartState(items);
    }

    updateCount = (index, value) => {
        const carts = { ...this.state.carts };
        const items = [...(carts[this.state.cartNo]?.items || [])];
        if (items[index] && value && value > 0) {
            items[index] = { ...items[index], count: value };
        }
        this.updateCartState(items);
    }

    deleteItem = (index) => {
        const carts = { ...this.state.carts };
        const items = [...(carts[this.state.cartNo]?.items || [])];
        items.splice(index, 1);
        this.updateCartState(items);
    }

    handleCartNameChange = (e) => {
        const val = e.target.value;
        const carts = { ...this.state.carts };
        const cartBase = { ...(carts[this.state.cartNo] || {}) };
        cartBase.cartName = val;
        carts[this.state.cartNo] = cartBase;
        this.setState({ carts });
    }

    sendFavoriteCart = () => {
        this.setState({ selectedItem: this.state.carts[this.state.cartNo] }, () => {
            this.setState({ cartselect: true });
        });
    }

    showHideCart = (val, cartId) => {
        this.setState({ cartselect: val });
        const { userOrg, org } = this.props;
        if (cartId) {
            if ((userOrg && userOrg.reseller && org && org.maker) || (userOrg && userOrg.buyer && org && org.reseller)) {
                this.props.cProps.history.push("/cart/" + cartId * 1);
            } else {
                this.props.cProps.history.push("/otasuke/cart/" + cartId * 1);
            }
        }
    }

    saveCart = () => {
        const carts = { ...this.state.carts };
        const cartBase = { ...(carts[this.state.cartNo] || {}) };
        const date = firebase.firestore.Timestamp.fromDate(new Date());
        cartBase.latestUpdate = date;
        delete cartBase['deletedItem'];
        delete cartBase['deletedText'];
        carts[this.state.cartNo] = cartBase;

        const { db, user, org } = this.props;
        const cartMainRef = db.collection('favorite_set').doc(user.id);
        const cartRef = cartMainRef.collection('favorite_set').doc(org.id);
        cartMainRef.set({ dummy: 'test' }, { merge: true });
        cartRef.set({
            [this.state.cartNo]: cartBase,
            update: date,
        }, { merge: true }).then(() => {
            this.setState({ modalSave: false, carts });
            message.success("保存しました。");
            this.getCarts();
        });
    }

    deleteFavoriteCart = () => {
        const { db, user, org } = this.props;
        const cartMainRef = db.collection('favorite_set').doc(user.id);
        const cartRef = cartMainRef.collection('favorite_set').doc(org.id);
        cartMainRef.set({ dummy: 'test' }, { merge: true });
        cartRef.set({
            [this.state.cartNo]: {},
            update: firebase.firestore.Timestamp.fromDate(new Date()),
        }, { merge: true }).then(() => {
            this.setState({ modalDelete: false });
            message.success("削除しました。");
            this.getCarts();
        });
    }

    addProduct = () => {
        this.saveCart();
        this.props.cProps.history.push("/items?cn=" + this.state.cartNo);
    }

    render() {
        if (!this.props.org) {
            return (
                <div style={{ padding: 24, textAlign: 'center' }}>
                    <Text type="secondary">取引先を選択してください。</Text>
                </div>
            );
        }

        const { userOrg, org } = this.props;
        const isBuyer = (userOrg && userOrg.reseller && org && org.maker) ||
            (userOrg && userOrg.buyer && org && org.reseller);

        const cartData = this.state.carts[this.state.cartNo] || { items: [], cartName: '' };
        const items = cartData.items || [];

        let total = 0;
        let taxTotal = 0;
        let taxes = {};
        const archiveFilter = items.filter(v => v.archive === true);

        items.forEach(item => {
            if (!item.deletedItem) {
                const subtotal = (item.count || 0) * (item.price || 0);
                total += subtotal;
                const tax = item.tax || 0;
                if (tax) {
                    taxes[tax] = (taxes[tax] || 0) + subtotal * tax;
                    taxTotal += Math.floor(subtotal * tax);
                }
            }
        });

        const postage = this.state.carriage || 0;
        const grandTotal = total + postage + taxTotal;
        const canOrder = items.length > 0 && !cartData.deletedItem && archiveFilter.length === 0;

        return (
            <div style={{ background: '#f5f5f5', minHeight: '100vh', paddingBottom: 80 }}>

                {/* Header */}
                <div style={{
                    background: '#fff',
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    borderBottom: '1px solid #f0f0f0',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10
                }}>
                    <Link to="/favorite/cart">
                        <Button type="text" icon={<ArrowLeftOutlined />} style={{ padding: 0 }} />
                    </Link>
                    <StarOutlined style={{ color: '#faad14', fontSize: 18 }} />
                    <Title level={5} style={{ margin: 0 }}>お気に入りセット {this.state.cartNo + 1}</Title>
                </div>

                <div style={{ padding: '12px 12px 0' }}>
                    {/* Cart name input */}
                    <Card style={{ marginBottom: 12, borderRadius: 10 }} bodyStyle={{ padding: '12px 14px' }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>セット名称</Text>
                        <Input
                            value={cartData.cartName}
                            onChange={this.handleCartNameChange}
                            placeholder="名称未設定"
                            style={{ marginTop: 4, borderRadius: 6 }}
                        />
                    </Card>

                    {/* Items */}
                    {this.state.loading ? (
                        <div style={{ textAlign: 'center', padding: 40 }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 28 }} spin />} />
                        </div>
                    ) : items.length === 0 ? (
                        <Card style={{ borderRadius: 10, textAlign: 'center', padding: 20 }}>
                            <Text type="secondary">商品がありません</Text>
                        </Card>
                    ) : (
                        <List
                            dataSource={items}
                            renderItem={(item, index) => (
                                <Card
                                    key={index}
                                    style={{ marginBottom: 10, borderRadius: 10, boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}
                                    bodyStyle={{ padding: '12px 14px' }}
                                >
                                    {/* Product name */}
                                    <div style={{ marginBottom: 8 }}>
                                        <Link to={`/items/${item.id}`}>
                                            <Text
                                                strong
                                                style={{ fontSize: 14, color: item.deletedItem ? '#ff4d4f' : '#1677ff' }}
                                            >
                                                {item.name}
                                            </Text>
                                        </Link>
                                        {item.deletedItem && (
                                            <Tag color="error" style={{ marginLeft: 8, fontSize: 11 }}>{item.deletedText}</Tag>
                                        )}
                                        {item.archive && (
                                            <Tag color="warning" style={{ marginLeft: 4, fontSize: 11 }}>
                                                {isBuyer ? '現在お取り扱いしていません' : 'アーカイブ済'}
                                            </Tag>
                                        )}
                                    </div>

                                    {/* Maker + price */}
                                    <Space style={{ marginBottom: 10 }} size={8}>
                                        {item.maker && (
                                            <Text type="secondary" style={{ fontSize: 12 }}>{item.maker}</Text>
                                        )}
                                        {!item.deletedItem && item.price && (
                                            <Text style={{ fontSize: 12, color: '#555' }}>@{Number(item.price).toLocaleString()}円</Text>
                                        )}
                                        {!item.deletedItem && item.price && item.count && (
                                            <Text strong style={{ color: '#d32f2f', fontSize: 13 }}>
                                                = ¥{(item.price * item.count).toLocaleString()}
                                            </Text>
                                        )}
                                    </Space>

                                    {/* Quantity + Delete row */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        {/* Quantity selector */}
                                        <Space>
                                            <Button
                                                size="small"
                                                icon={<MinusOutlined />}
                                                onClick={() => this.decrease(index)}
                                                style={{ borderRadius: 6 }}
                                            />
                                            <InputNumber
                                                min={0}
                                                value={item.count}
                                                onChange={(val) => this.updateCount(index, val)}
                                                style={{ width: 60, textAlign: 'center', borderRadius: 6 }}
                                                size="small"
                                            />
                                            <Button
                                                size="small"
                                                icon={<PlusOutlined />}
                                                onClick={() => this.increase(index)}
                                                style={{ borderRadius: 6 }}
                                            />
                                        </Space>

                                        {/* Delete button */}
                                        <Button
                                            danger
                                            size="small"
                                            icon={<DeleteOutlined />}
                                            onClick={() => this.deleteItem(index)}
                                            style={{ borderRadius: 6 }}
                                        >
                                            削除
                                        </Button>
                                    </div>
                                </Card>
                            )}
                        />
                    )}

                    {/* Summary */}
                    {items.length > 0 && (
                        <Card style={{ borderRadius: 10, marginBottom: 12 }} bodyStyle={{ padding: '12px 16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                <Text type="secondary">運賃</Text>
                                <Text>{postage.toLocaleString()}円</Text>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                <Text type="secondary">小計</Text>
                                <Text>{total.toLocaleString()}円</Text>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                <Text type="secondary">消費税額</Text>
                                <Text>{taxTotal.toLocaleString()}円</Text>
                            </div>
                            {Object.keys(taxes).sort((a, b) => b - a).map(rate => (
                                <div key={rate} style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0 2px 12px' }}>
                                    <Text type="secondary" style={{ fontSize: 12 }}>消費税{rate * 100}%</Text>
                                    <Text style={{ fontSize: 12 }}>{Math.floor(taxes[rate]).toLocaleString()}円</Text>
                                </div>
                            ))}
                            <Divider style={{ margin: '8px 0' }} />
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Text strong>合計</Text>
                                <Text strong style={{ color: '#d32f2f', fontSize: 16 }}>{grandTotal.toLocaleString()}円</Text>
                            </div>
                        </Card>
                    )}

                    {/* Add product button */}
                    <Button
                        block
                        icon={<ShoppingCartOutlined />}
                        onClick={this.addProduct}
                        style={{ marginBottom: 10, borderRadius: 8 }}
                    >
                        商品を追加する
                    </Button>

                    {/* Cart add button */}
                    <Button
                        block
                        type="primary"
                        size="large"
                        icon={<ShoppingCartOutlined />}
                        disabled={!canOrder}
                        onClick={this.sendFavoriteCart}
                        style={{ borderRadius: 8, marginBottom: 10, height: 48 }}
                    >
                        {isBuyer ? 'このセットをカートに追加' : 'このセットをお助けカートに追加'}
                    </Button>

                    {/* Delete / Save row */}
                    <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
                        <Button
                            block
                            danger
                            icon={<DeleteOutlined />}
                            disabled={items.length === 0}
                            onClick={() => this.setState({ modalDelete: true })}
                            style={{ borderRadius: 8 }}
                        >
                            削除
                        </Button>
                        <Button
                            block
                            icon={<SaveOutlined />}
                            disabled={!cartData.cartName && !canOrder}
                            onClick={() => this.setState({ modalSave: true })}
                            style={{ borderRadius: 8 }}
                        >
                            保存
                        </Button>
                    </div>
                </div>

                {/* Cart select modal */}
                {isBuyer ? (
                    <FavoriteCartAllSelect
                        isOpen={this.state.cartselect}
                        isOpenEvent={(val, cartId) => this.showHideCart(val, cartId)}
                        favouriteCartId={this.state.cartNo}
                        db={this.props.db}
                        user={this.props.user}
                        data={this.state.selectedItem}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                ) : (
                    <FavoriteCartAllSelectOtasuke
                        isOpen={this.state.cartselect}
                        isOpenEvent={(val, cartId) => this.showHideCart(val, cartId)}
                        favouriteCartId={this.state.cartNo}
                        db={this.props.db}
                        user={this.props.user}
                        data={this.state.selectedItem}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                )}

                {/* Save confirm modal */}
                <Modal
                    title="お気に入りセット保存"
                    open={this.state.modalSave}
                    onOk={this.saveCart}
                    onCancel={() => this.setState({ modalSave: false })}
                    okText="保存する"
                    cancelText="キャンセル"
                    centered
                >
                    <p>お気に入りセット「<strong>{cartData.cartName}</strong>」を保存します。</p>
                </Modal>

                {/* Delete confirm modal */}
                <Modal
                    title="お気に入りセット削除"
                    open={this.state.modalDelete}
                    onOk={this.deleteFavoriteCart}
                    onCancel={() => this.setState({ modalDelete: false })}
                    okText="削除する"
                    cancelText="キャンセル"
                    okButtonProps={{ danger: true }}
                    centered
                >
                    <p>お気に入りセット「<strong>{cartData.cartName || '名称未設定'}</strong>」を削除します。よろしいですか？</p>
                </Modal>
            </div>
        );
    }
}

export default MobileFavoriteCart;
